// 电话催收管理-路由
var TelWaitingCollectCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-waiting-collect-case-manage.vue');
}; //电催待分配
var TelTeamCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-team-case-manage.vue');
}; //团队案件池
var TelPersonCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-person-case-manage.vue');
}; //个人案件池
var TelRecoverCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-recover-case-manage.vue');
}; //回收案件池
var TelReturnCCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-returnc-case-manage.vue');
}; //归C案件池
var TelSettleCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-settle-case-manage.vue');
}; //结清案件池
var TelStopCaseManage = function () {
    return import('~/pages/telephone-collection-manage/tel-stop-case-manage.vue');
}; //停催案件池
export default [
    {
        path: '/telephone-collection-manage/tel-waiting-collect-case-manage',
        name: 'tel-waiting-collect-case-manage',
        component: TelWaitingCollectCaseManage,
    },
    {
        path: '/telephone-collection-manage/tel-team-case-manage',
        name: 'tel-team-case-manage',
        component: TelTeamCaseManage,
    },
    {
        path: '/telephone-collection-manage/tel-person-case-manage',
        name: 'tel-person-case-manage',
        component: TelPersonCaseManage,
    },
    {
        path: '/telephone-collection-manage/tel-recover-case-manage',
        name: 'tel-recover-case-manage',
        component: TelRecoverCaseManage,
    },
    {
        path: '/telephone-collection-manage/tel-returnc-case-manage',
        name: 'tel-returnc-case-manage',
        component: TelReturnCCaseManage,
    },
    {
        path: '/telephone-collection-manage/tel-settle-case-manage',
        name: 'tel-settle-case-manage',
        component: TelSettleCaseManage,
    },
    {
        path: '/telephone-collection-manage/tel-stop-case-manage',
        name: 'tel-stop-case-manage',
        component: TelStopCaseManage,
    },
];
